"use strict";

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function handleConsentResponse(isAccepted) {
    const trackingConsentData = $(".tracking-consent");
    const acceptUrl = trackingConsentData.data("accept");
    const rejectUrl = trackingConsentData.data("reject");
    const tokenName = trackingConsentData.data("tokenname");
    const token = trackingConsentData.data("token");
    const data = {};
    data[tokenName] = token;
    let urlContent = isAccepted ? acceptUrl : rejectUrl;

    $.ajax({
        url: urlContent,
        type: "post",
        data: data,
        dataType: "json",
        success: function () {
            // TODO: Block GTM tracking once GTM gets implemented
        },
        error: function (err) {
            // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        }
    });
}

module.exports = function () {
    $(document).on("click", "#onetrust-accept-btn-handler, #accept-recommended-btn-handler", function () {
        handleConsentResponse(true);
    });

    $(document).on("click", ".ot-pc-refuse-all-handler", function () {
        handleConsentResponse(false);
    });
};
